<template>
    <div class="feed">
<!--     <first-Component></first-Component>-->
      <img class="banner animated fadeIn" src="../assets/f.png" alt="" id="d1">
      <div class="link animated fadeInLeft">
        <div class="main">
          <span class="title">{{$t('feed.link[0]')}}</span>
          <span> {{$t('feed.link[1]')}}</span>
        </div>
      </div>
      <p class="oneTitle animated fadeInRight">{{$t('feed.title')}}</p>
      <p class="ia wow fadeInUp" style="font-family: light2">{{$t('feed.title1')}}</p>
    <div class="write wow fadeInUp">
      <input type="text" :placeholder="$t('feed.form[0]')" v-model="form.company">
      <input type="text" :placeholder="$t('feed.form[1]')" class="num" v-model="form.phone">
      <input type="text" :placeholder="$t('feed.form[2]')" v-model="form.email">
      <input type="text" :placeholder="$t('feed.form[3]')" v-model="form.subject">
      <textarea v-model="form.ly"  :placeholder="$t('feed.form[4]')"></textarea>
      <div class="aB wow fadeInUp" @click="confirm">
        <Btn-Component :text="$t('btn3')"></Btn-Component>
      </div>
    </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
</template>

<script>
  import firstComponent from  "./first"
  import footComponent from "./foot"
  import BtnComponent from "./btn"
  import Scrollbar from 'smooth-scrollbar';
  import qs from 'qs'
    export default {
        name: "feed",
      data(){
          return{
            form:{
             company:'',
              phone:'',
              email:'',
              subject:'',
              ly:''
            }
          }
      },
      components:{firstComponent,footComponent,BtnComponent},
      mounted(){
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
      },
      methods:{
          confirm(){
            if(this.form.company==='' || this.form.phone==='' || this.form.email==='' || this.form.subject===''
            || this.form.ly===''){
              this.$notify({
                title: 'Fail',
                message: 'Submitted Failed',
                offset: 100
              })
            }else{
              const url ='/php/form.php'
              this.$axios.post(url,
                qs.stringify(
                  this.form
                )
              ).then(res => {
                if(res.status==200)
                {
                  this.$notify({
                    title: 'Success',
                    message: 'Submitted successfully',
                    offset: 100
                  })
                  this.form={
                    company:'',
                    phone:'',
                    email:'',
                    subject:'',
                    ly:''
                  }
                }else{
                  this.$notify({
                    title: 'Fail',
                    message: 'Submission Failed',
                    offset: 100
                  })
                }
              })
            }
          },
        gotoTop(){
          Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
        },
      }
    }
</script>

<style scoped>
.feed{
  width:100%;
}
.banner{
  width:100%;
  display: block;
}
.link{
  width:100%;
  padding: 30px 0;
  border-bottom: 1px solid rgba(250, 250, 250, 1);
}
.link .main{
  width:1280px;
  margin: 0 auto;
  text-align: left;
}
.link .main span{
  color:#C9382C;
  text-transform: uppercase;
}
.link .main .title{
  color:black;
}
  .oneTitle{
    text-align: center;
    font-weight: bold;
    font-size: 25px;
    text-transform: uppercase;
    margin-top: 60px;
    position: relative;
    width:30%;
    margin-left: 35%;
    padding-bottom: 20px;
  }
  .oneTitle::before{
    content: '';
    display: inline-block;
    width:10%;
    left:45%;
    bottom:0;
    height:2px;
    position: absolute;
    background-color: #C9382C;
  }
  .ia{
    margin-top: 50px;
  }
  .write{
    width:1280px;
    margin: 60px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 60px;
    justify-content: space-between;
    position: relative;
  }
  .write input{
    width:45%;
    border: 1px solid rgba(197, 200, 199, 1);
    height:30px;
    padding-left: 2%;
    margin-top: 30px;
    position: relative;
  }
  .write textarea{
    width:100%;
    margin-top: 40px;
    height:160px;
  }
  .aB{
    width:100%;
    position: absolute;
    right:0;
    bottom:0;
    text-align: right;
  }
@media screen and (max-width:450px){
  .banner{
    height:100vh;
    object-fit: cover;
  }
  .feed{
    overflow: hidden;
  }
  .link .main,.write{
    width:90%;
    margin-left: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/feed.vue